module.exports = __webpack_public_path__ + "img/horizontal_3_3_pp3_3016.5fe1ac3e.png";